module.exports = __webpack_public_path__ + "static/media/Books_m_mr.17e65aca.jpg";